<template>
  <div class="ps-6 pe-5 py-6"></div>
</template>

<script>
export default {}
</script>
